import { c as _c } from "react/compiler-runtime";
import { FaroSelect } from "@components/common/faro-select/faro-select";
import { LabelWithHelp } from "@components/common/label-with-help";
import { ExternalLinks } from "@components/external-links";
import { getRoleMenuItemSx, RoleMenuItem } from "@components/role/role-menu-item";
import { Divider, MenuItem } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { formatUserRoleType } from "@utils/data-display";
/** Shows a selector in which user can choose a role for different subjects, i.e company, project, group */
export function SelectRole(t0) {
  const $ = _c(32);
  const {
    roles,
    disabledRoles: t1,
    variant,
    selectedRole,
    onChange,
    label,
    link,
    isRequired: t2,
    dataTestId,
    menuProps
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const disabledRoles = t3;
  const isRequired = t2 === undefined ? true : t2;
  let t4;
  if ($[2] !== isRequired || $[3] !== label || $[4] !== variant) {
    t4 = variant === "outlined" && <LabelWithHelp title={label} isRequired={isRequired} />;
    $[2] = isRequired;
    $[3] = label;
    $[4] = variant;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== selectedRole) {
    t5 = selectedRole ? () => formatUserRoleType(selectedRole) : undefined;
    $[6] = selectedRole;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== disabledRoles || $[9] !== roles || $[10] !== selectedRole || $[11] !== variant) {
    let t7;
    if ($[13] !== disabledRoles || $[14] !== selectedRole || $[15] !== variant) {
      t7 = role => <MenuItem key={role} value={role} disabled={disabledRoles.includes(role)} sx={getRoleMenuItemSx({
        isTableCell: variant === "borderless"
      })}><RoleMenuItem role={role} isRoleSelected={role === selectedRole} /></MenuItem>;
      $[13] = disabledRoles;
      $[14] = selectedRole;
      $[15] = variant;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    t6 = roles.map(t7);
    $[8] = disabledRoles;
    $[9] = roles;
    $[10] = selectedRole;
    $[11] = variant;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[17] !== link) {
    t7 = link && <Box sx={{
      mb: "8px"
    }}><Divider sx={{
        m: "8px"
      }} /><ExternalLinks link={link} text="Learn about permissions levels" sx={{
        fontSize: "12px",
        px: "16px",
        mx: "8px",
        color: "primary.main"
      }} /></Box>;
    $[17] = link;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== dataTestId || $[20] !== label || $[21] !== menuProps || $[22] !== onChange || $[23] !== selectedRole || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== variant) {
    t8 = <FaroSelect label={label} dataTestId={dataTestId} variant={variant} value={selectedRole} onChange={onChange} renderValue={t5} menuProps={menuProps}>{t6}{t7}</FaroSelect>;
    $[19] = dataTestId;
    $[20] = label;
    $[21] = menuProps;
    $[22] = onChange;
    $[23] = selectedRole;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = variant;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t4 || $[30] !== t8) {
    t9 = <>{t4}{t8}</>;
    $[29] = t4;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
}